/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";

const ContactTableRow = ({ contact }) => (
  <tr>
    <td>{contact.name}</td>
    <td>{contact.email}</td>
    <td>{contact.mobile}</td>
  </tr>
);
ContactTableRow.propTypes = {
  contact: PropTypes.object.isRequired
};

const ContactList = ({ contacts }) => {
  let tableContent;
  if (contacts.length) {
    tableContent = contacts.map(contact => (
      <ContactTableRow key={contact.id} contact={contact} />
    ));
  } else {
    tableContent = [
      <tr key="1">
        <td colSpan="3">There are no existing contacts for this locations</td>
      </tr>
    ];
  }
  return (
    <Table striped bordered condensed hover>
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Mobile</th>
        </tr>
      </thead>
      <tbody>{tableContent}</tbody>
    </Table>
  );
};
ContactList.propTypes = {
  contacts: PropTypes.array
};
ContactList.defaultProps = {
  contacts: []
};

export default ContactList;



// WEBPACK FOOTER //
// ./src/dev/ContactList.js